import React from "react";
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";

import ResizeHorizontal from "./assets/resize-horizontal.svg";
import ChatIcon from "./assets/chat-icon.svg";
import CloseIcon from "./assets/close-icon.svg";
import LoadingIcon from "./assets/loading-icon.svg";

import ChatbotPrompts from "./chatbot_prompts";
import ChatbotInput from "./chatbot_input";

import useChatbot from "./chatbot.controller";
import useDragEvent from "./useDragEvent";

import { getText } from "../../helpers";

import "./chatbot.css";

const RESIZABLE_CONFIG = {
  minHeight: "50%",
  minWidth: "25%",
  defaultSize: { width: "50%", height: "calc(100% - 190px)" },
  handleWrapperClass: "chatbot-resizable",
  handleClasses: {
    top: "chatbot-resizable-top",
    topLeft: "chatbot-resizable-topleft",
    left: "chatbot-resizable-left",
  },
  enable: {
    left: true,
    top: true,
    topLeft: true,
  },
  handleComponent: {
    left: <img className="chatbot-resizable-icon" src={ResizeHorizontal} alt=""></img>,
    topLeft: <img className="chatbot-resizable-icon" src={ResizeHorizontal} alt=""></img>,
    top: <img className="chatbot-resizable-icon" src={ResizeHorizontal} alt=""></img>,
  },
};

export default function Chatbot(props) {
  const controller = useChatbot(props);
  const buttonController = useDragEvent("chatbot-button-position");
  const isContextLoading = props.planUploadStatus.status === "uploading";
  const isContextLoadingFailed = props.planUploadStatus.status === "upload_failed";
  const isShowPrompt = !isContextLoading && !isContextLoadingFailed;

  return (
    <React.Fragment>
      <Draggable
        defaultClassName="chatbot-button-draggable"
        handle=".chatbot-button"
        position={buttonController.position}
        onDrag={buttonController.onDrag}
        onStop={buttonController.onDragStop}
      >
        <div className="chatbot-button">
          <img src={ChatIcon} alt="" height="100%"></img>
          <span>{getText("AI Chatbot")}</span>
          {/** The div bellow will prevent dragging only the icon and highlighting the text */}
          <div className="chatbot-button-clickable" onClick={!buttonController.isDragging && controller.onToggle}></div>
        </div>
      </Draggable>
      {controller.isShown ? (
        <Draggable
          defaultClassName="chatbot"
          defaultClassNameDragged="chatbot-dragged"
          handle=".chatbot-header"
          position={controller.dragEvent.position}
          onDrag={controller.dragEvent.onDrag}
          onStop={controller.dragEvent.onDragStop}
        >
          <Resizable {...RESIZABLE_CONFIG} size={controller.modalSize} onResizeStop={controller.onResizeStop}>
            <div className="chatbot-container">
              <div className="chatbot-header">
                <div className="chatbot-instructions">{getText("Ask AI Chatbot about Risk Plans")}</div>
                <div className="chatbot-delete-icon" onClick={controller.onClose}>
                  <img src={CloseIcon} alt="" height="100%"></img>
                </div>
              </div>
              {isContextLoading && (
                <div className="chatbot-center-content">
                  <div className="loader-indicator">
                    <img src={LoadingIcon} alt="" height="100%"></img>
                    <br />
                    <div>{getText("Current plan is being loaded to AI Chatbot context")}...</div>
                  </div>
                </div>
              )}
              {isContextLoadingFailed && (
                <div className="chatbot-center-content">
                  <div>{getText("Failed to load the current Plan to AI Chatbot context.")}</div>
                </div>
              )}
              {isShowPrompt && (
                  <div className="chatbot-content">
                    <ChatbotPrompts controller={controller} />
                    <ChatbotInput controller={controller} />
                  </div>
                )
              }
            </div>
          </Resizable>
        </Draggable>
      ) : null}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/chatbot/chatbot.js